import {atom} from "jotai";
import {RasterLayerType} from "../types/domain/rasterLayerType";
import {MapSelectedLayers} from "../types/mapSelectedLayers";
import {MapRef} from "react-map-gl";

export const mainMapSelectedLayersAtom = atom<MapSelectedLayers>({
    chosenLayer: RasterLayerType.MOISTURE_STATUS,
    layerType: "raster",
    legendScope: "area",
    satellite: true,
    streets: true,
    madera: false,
});

export const maderaMainMapSelectedLayersAtom = atom<MapSelectedLayers>({
    chosenLayer: RasterLayerType.ACTUAL_EVAPOTRASPIRATION_APPLIED_WATER_CUMULATIVE,
    layerType: "raster",
    legendScope: "area",
    satellite: true,
    streets: true,
    madera: false,
});

export const splitMapSelectedLayersAtom = atom<MapSelectedLayers>({
    chosenLayer: RasterLayerType.MOISTURE_STATUS,
    layerType: "raster",
    legendScope: "area",
    satellite: true,
    streets: true,
    madera: false,
});

export const mapRefAtom = atom<MapRef | null>();
